<template>
    <template v-if="url">
        <video v-if="isVideo"
               width="100%" controls
               :poster="poster"
               preload="metadata"
               playsinline style="border-radius: 15px; border: 1px solid #f5f5f5">
            <source :src="url" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <audio style="width: 100%" controls :src="url" v-else/>
    </template>

    <p v-else>
        <small v-if="progress <  0">
            视频生成过程发生未知错误，您可上报此问题给管理员或重新上传。
        </small>
        <a-space v-else>
            <a>
                <template v-if="isVideo">
                    <VideoCameraOutlined class="big-icon" v-if="status === 2"/>
                    <VideoCameraAddOutlined class="big-icon" v-else/>
                </template>
                <template v-else>
                    <AudioOutlined class="big-icon" v-if="status === 2"/>
                    <AudioMutedOutlined  class="big-icon" v-else/>
                </template>
            </a>
            <span>
                {{progress < 5? 'AI'+cn+'正在生成中，预计需要5分钟...': '无'}}
            </span>
        </a-space>
    </p>
</template>

<script>
    import {
        AudioMutedOutlined, AudioOutlined,
        VideoCameraOutlined, VideoCameraAddOutlined
    } from '@ant-design/icons-vue';

    export default {
        name: "PubmedMedia",
        props: ['media', 'paperNo', 'status', 'url', 'progress', 'cn', 'ppts'],
        components: {
            AudioMutedOutlined, AudioOutlined,
            VideoCameraOutlined, VideoCameraAddOutlined,
        },
        data(){
            return {
                isVideo: this.media === 'video',
                loading: false,
                paper_no: Number(this.paperNo),
                media_data: '',
                poster: Array.isArray(this.ppts)? (this.ppts[0]?.ppt_page): ''
            }
        },
        mounted(){
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
